// src/api/labResultApi.js
import axiosInstance from "../axios";

/**
 * Criar um novo resultado de laboratório (1:1 com experimento).
 */
export async function createLabResult(labResult) {
    const { data } = await axiosInstance.post("/lab-results", labResult);
    return data; // retorna o objeto LabResult salvo
}

/**
 * Atualizar um resultado existente pelo experimentId.
 */
export async function updateLabResult(experimentId, labResult) {
    const { data } = await axiosInstance.put(`/lab-results/${experimentId}`, labResult);
    return data; // retorna o objeto atualizado
}

/**
 * Buscar resultado de laboratório pelo experimentId.
 */
export async function getLabResultByExperimentId(experimentId) {
    const { data } = await axiosInstance.get(`/lab-results/${experimentId}`);
    return data; // retorna LabResult ou 404
}

/**
 * Deletar resultado de laboratório por experimentId.
 */
export async function deleteLabResult(experimentId) {
    await axiosInstance.delete(`/lab-results/${experimentId}`);
    return true; // sucesso → retorna true
}
